<template>
  <!-- 5. Stop submission -->
  <div v-if="stopSubmissionVisible" class="lock-submission-config" @click="handleCheckNeedUpgradePlan">
    <label v-if="isLockSubmissionInternalVersion" class="mr-2" for="stop-submission">
      <aha-icon
        name="chat2"
        width="20"
        height="20"
        viewBox="0 0 24 25"
        class="settings-icon mb-0.5 mr-1"
      ></aha-icon>
      {{ $i18nPresenter.t('close_submission') }}
      <IconNeedUpgradePlan
        v-if="planBenefit.interactivePresentation"
        ref="iconNeedUpgradePlanComponentLockSubmission"
        :noPermission="planBenefit.interactivePresentation &&
          !planBenefit.interactivePresentation.advancedSubmissionControls"
        :defaultTooltip="$i18nPresenter.t(
          'Initially close submissions to introduce the slide, then manually open to accept responses.')"
        left="-120px"
        :upgradePlan="planBenefit.interactivePresentation.advancedSubmissionControls_planName"
        featureName="Lock Submissions"
      />
    </label>
    <label v-else class="mr-2" for="stop-submission">
      <aha-icon
        name="chat2"
        width="20"
        height="20"
        viewBox="0 0 24 25"
        class="settings-icon mb-0.5 mr-1"
      ></aha-icon>
      {{ $i18nPresenter.t('Lock submissions') }}
      <IconNeedUpgradePlan
        v-if="planBenefit.interactivePresentation"
        ref="iconNeedUpgradePlanComponentLockSubmission"
        :noPermission="planBenefit.interactivePresentation &&
          !planBenefit.interactivePresentation.advancedSubmissionControls"
        :defaultTooltip="$i18nPresenter.t(
          'Initially close submissions to introduce the slide, then manually open to accept responses.')"
        left="-120px"
        :upgradePlan="planBenefit.interactivePresentation.advancedSubmissionControls_planName"
        featureName="Lock Submissions"
      />
    </label>
    <toggle-button
      v-model="stopSubmission"
      :width="35"
      :height="20"
      class="ml-auto"
      :sync="true"
      :color="{ checked: '#6A1EBB', unchecked: '#D3D7E1' }"
      @change="changeStopSubmission()"
      :disabled="planBenefit.interactivePresentation &&
        !planBenefit.interactivePresentation.advancedSubmissionControls"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import IconNeedUpgradePlan from '@/components-v2/my-plan/IconNeedUpgradePlan.vue'

export default {
  components: {
    IconNeedUpgradePlan,
  },
  props: {
    updateSettingSlide: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      stopSubmission: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
    }),
    stopSubmissionVisible() {
      const slideTypes = ['bulletPoints', 'pickAnswer', 'leaderboard', 'question', 'ideas']

      return !slideTypes.includes(this.slideActive.type)
    },
    stopSubmissionTooltip() {
      if (this.isLockSubmissionInternalVersion) return this.$i18nPresenter.t('close_submission_to_into')

      return this.$i18nPresenter.t('Lock submission on this slide to introduce it before allowing the audience to vote.')
    },
    isInternalUser() {
      return this.currentUser && this.currentUser.email &&
        (this.currentUser.email.includes('@a.com') ||
        this.currentUser.email.includes('@ahaslides.com'))
    },
    isLockSubmissionInternalVersion() {
      return this.isInternalUser
    },
  },
  watch: {
    'slideActive.stopSubmission': function watchStopSubmission() {
      this.stopSubmission = !!this.slideActive.stopSubmission
    },
  },
  created() {
    this.stopSubmission = !!this.slideActive.stopSubmission
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    changeStopSubmission() {
      this.updateSlideActiveAction({
        stopSubmission: this.stopSubmission,
      })
      this.updateSettingSlide(5)
    },
    handleCheckNeedUpgradePlan() {
      if (this.planBenefit.interactivePresentation &&
        !this.planBenefit.interactivePresentation.advancedSubmissionControls) {
        this.$refs.iconNeedUpgradePlanComponentLockSubmission.toggleTooltip()
      }
    },
  },
}
</script>

<style lang="scss">
.lock-submission-config {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
  &:hover .title-table-presentation-tooltip {
      opacity: 1;
    }
  .title-table-presentation-tooltip {
    opacity: 0;
    margin-top: -8px;
    transition: opacity 0.2s ease;
  }
}
</style>
